<script setup>
import {ref} from "vue";
import { useUserStore } from "@/stores/userStore";
import {useI18n} from "vue-i18n";
import CustomButton from "@/components/Button/Button.vue";
import {useRouter} from "vue-router";

const dialog = ref(false);
const { t } = useI18n();
const userStore = useUserStore();
const router = useRouter();

const openDialog = () => {
  dialog.value = true;
};
const closeDialog = () => {
  dialog.value = false;
};

async function handleDeactivateAccount() {
  try {
    await userStore.deactivateUserAccount();
    closeDialog()
    router.push("/");
  } catch (error) {
    console.error("Deactivation failed", error);
  }
}
</script>

<template>

  <!-- Trigger Link -->
  <div class="responsive-body-xsmall font-bold mainContainerX">
    {{ t('changePassword.deactivateText') }}
    <span class="underline cursor-pointer transition" @click="openDialog">
      {{ t('changePassword.deactivateLink') }}
    </span>
  </div>

  <!-- Deactivation Dialog -->
  <v-dialog v-model="dialog" max-width="500px">
    <v-card class="p-6 rounded-lg shadow-lg">
      <!-- Header with Close Button -->
      <div class="cursor-pointer self-end hidden sm:block p-2 hover:opacity-70 transition-opacity" type="default" @click="closeDialog">
        <img src="@/assets/icons/svg/Close_16x16.svg" alt="Close" width="18"/>
      </div>
      <div class="flex justify-between items-center py-4 px-7">
        <span class="responsive-title-6 font-semibold text-black">{{ t('changePassword.deactivateTitle') }}</span>
      </div>


      <v-card-text class="text-black responsive-body-medium">
        <p class="mb-2">{{ t('changePassword.deactivateBody1') }}</p>
        <p>{{ t('changePassword.deactivateBody2') }}</p>
      </v-card-text>

      <!-- Action Buttons -->
      <v-card-actions class="flex gap-4 mx-4 py-4 justify-space-between">
        <CustomButton type="black"
                      :rounded="true"
                      :outlined="false"
                      @click="handleDeactivateAccount"
                      class="deactivate-btn w-1/3 hover:opacity-30 hover:text-white hover:border-red font-semibold responsive-body-medium"

        >
          {{ t('changePassword.deactivate') }}
        </CustomButton>
        <CustomButton type="black"
                      :rounded="true"
                      :outlined="false"
                      @click="closeDialog"
                      class="w-1/3 hover:bg-black hover:text-white hover:border-black font-semibold responsive-body-medium"
        >
          {{ t('changePassword.cancel') }}
        </CustomButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.deactivate-btn {
  background-color: #ff0000 !important;
}

</style>